import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { ReportFilterComponent } from './report-filter.component';
import { AppContentOverlayModule } from 'app/modules/shared/components/content-overlay/content-overlay.module';
import { AppCheckboxModule } from 'app/modules/shared/components/checkbox/checkbox.module';
import { AppSingleFilterModule } from 'app/modules/shared/components/app-single-filter/app-single-filter.module';
import { AppMultipleFilterModule } from 'app/modules/shared/components/app-multiple-filter/app-multiple-filter.module';
import { AppDirectiveModule } from 'app/directive/shared-directive.module';
import { ShopLocationDropdownModule } from 'app/modules/shared/components/shop-location-dropdown/shop-location-dropdown.module';
import { TooltipModule } from 'primeng/tooltip';
import { AppRadioButtonModule } from 'app/modules/shared/components/radio-button/radio-button.module';

@NgModule({
  imports: [CommonModule, NgxMaskDirective, NgxMaskPipe, AppContentOverlayModule, AppCheckboxModule, AppSingleFilterModule, 
    AppMultipleFilterModule, AppDirectiveModule, ShopLocationDropdownModule, TooltipModule, AppRadioButtonModule],
  declarations: [ReportFilterComponent],
  exports: [ReportFilterComponent],
})
export class AppReportFilterModule {}
